<template>
  <div id="loginMaster container">
    <div class="principal">
      <nav class="navbar nav-masters">
        <a class="navbar-brand mx-auto">
          <img
            src="../../../../public/img/images/logo-emb.png"
            class="logo-embajadores"
          />
        </a>
      </nav>
    </div>
    <div class="div-login">
      <div class="contenedor-login">
        <p class="ingresa">
          {{
            this.idioma == "ES"
              ? "Cambia tu contraseña"
              : "Change your password"
          }}
        </p>
        <form autocomplete="off" @submit.prevent="cambiarContraseniaMaster">
          <div class="inner-addon right-addon">
            <i
              class="fas fa-eye-slash icono-pass"
              style="cursor: pointer !important;"
              v-if="mostrando == false"
              @click="Mostrar"
            />
            <i
              class="far fa-eye icono-pass"
              style="cursor: pointer !important;"
              v-if="mostrando == true"
              @click="Mostrar"
            />
            <input
              :type="tipoContrasenia"
              v-model="datos.contrasena"
              class="form-control input-login"
              name="password"
              :placeholder="
                this.idioma == 'ES' ? 'Nueva contraseña' : 'New password'
              "
              required
            />
          </div>
          <div class="inner-addon right-addon">
            <i
              class="fas fa-eye-slash icono-pass"
              style="cursor: pointer !important;"
              v-if="mostrandoConfirmacion == false"
              @click="MostrarConfirmacion"
            />
            <i
              class="far fa-eye icono-pass"
              style="cursor: pointer !important;"
              v-if="mostrandoConfirmacion == true"
              @click="MostrarConfirmacion"
            />
            <input
              :type="tipoConfirmacion"
              class="form-control input-login"
              name="password"
              v-model="confirmacion"
              :placeholder="
                this.idioma == 'ES' ? 'Confirmación' : 'Confirmation'
              "
              required
            />
          </div>
          <div class="row">
            <div
              class="col-lg-12 col-md-12 col-sm-12"
              style="text-align: justify;"
            >
              <small class="etiqueta">
                {{
                  this.idioma == "ES"
                    ? "Recuerda, la contraseña debe tener:"
                    : "Remember, the password must have:"
                }}
              </small>
              <ul>
                <li class="lista-reglas">
                  {{
                    this.idioma == "ES"
                      ? "Al menos una mayúscula y una minúscula"
                      : "At least one uppercase and one lowercase letter"
                  }}
                </li>
                <li class="lista-reglas">
                  {{
                    this.idioma == "ES"
                      ? "Al menos uno de estos caracteres especiales (#, $, ^, +, =, !,*, ( , ), @, %)"
                      : "At least one of these special characters (#, $, ^, +, =, !,*, ( , ), @, %)"
                  }}
                </li>
                <li class="lista-reglas">
                  {{
                    this.idioma == "ES"
                      ? "Al menos un número"
                      : "At least one number"
                  }}
                </li>
                <li class="lista-reglas">
                  {{
                    this.idioma == "ES"
                      ? "Una longitud entre 8 y 12 caracteres"
                      : "Length between 8 and 12 characters"
                  }}
                </li>
              </ul>
            </div>
          </div>
          <button
            type="submit"
            id="sendlogin"
            class="btn btn-block btn-login w-100"
          >
            {{ this.idioma == "ES" ? "Cambiar contraseña" : "Change password" }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
const regExContrasenia = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,12}$/;
import axios from "axios";
export default {
  name: "CambiarContrasenia",
  data() {
    return {
      idioma: "ES",
      datos: {
        usuarioId: null,
        token: null,
        contrasena: null,
      },
      confirmacion: null,
      tipoContrasenia: "password",
      tipoConfirmacion: "password",
      mostrando: false,
      mostrandoConfirmacion: false,
    };
  },
  mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.datos.usuarioId = urlParams.get("usuarioId");
    this.datos.token = urlParams.get("token");
    this.idioma = urlParams.get("idioma");
  },
  watch: {
    "datos.contrasena": function() {
      let longitud = this.datos.contrasena.length;
      if (longitud > 12) {
        this.datos.contrasena = this.datos.contrasena.substring(
          0,
          longitud - 1
        );
      }
    },
    confirmacion: function() {
      let longitud = this.confirmacion.length;
      if (longitud > 12) {
        this.confirmacion = this.confirmacion.substring(0, longitud - 1);
      }
    },
  },
  methods: {
    Mostrar() {
      if (this.mostrando == false) {
        this.tipoContrasenia = "text";
        this.mostrando = true;
      } else {
        this.tipoContrasenia = "password";
        this.mostrando = false;
      }
    },
    MostrarConfirmacion() {
      if (this.mostrandoConfirmacion == false) {
        this.tipoConfirmacion = "text";
        this.mostrandoConfirmacion = true;
      } else {
        this.tipoConfirmacion = "password";
        this.mostrandoConfirmacion = false;
      }
    },
    cambiarContraseniaMaster: function() {
      let contrasena = this.datos.contrasena;
      let confirmacionContrasena = this.confirmacion;
      if (contrasena.charAt(0) === " ") {
        contrasena = contrasena.substring(0);
      }
      if (contrasena.charAt(contrasena.length - 1) === " ") {
        contrasena = contrasena.slice(0, -1);
      }
      if (confirmacionContrasena.charAt(0) === " ") {
        contrasena = contrasena.substring(0);
      }
      if (confirmacionContrasena.charAt(contrasena.length - 1) === " ") {
        contrasena = contrasena.slice(0, -1);
      }

      if (contrasena !== confirmacionContrasena) {
        this.$fire({
          title:
            this.idioma == "ES"
              ? "La nueva contraseña y la confirmación deben coincidir."
              : "The new password and confirmation must match.",
          confirmButtonText: this.idioma == "ES" ? "Aceptar" : "Accept"
        });
      } else if (!regExContrasenia.test(contrasena)) {
        this.$fire({
          title:
            this.idioma == "ES"
              ? "La contraseña no cumple con los parámetros de seguridad"
              : "Password does not meet security parameters ",
          confirmButtonText: this.idioma == "ES" ? "Aceptar" : "Accept"
        });
      } else {
        axios
          .post("api/Identity/ActualizarContrasenia", this.datos)
          .then(response => {
            if (response.data.estado === 0) {
              this.$fire({
                title: response.data.mensaje,
                confirmButtonText: this.idioma == "ES" ? "Aceptar" : "Accept"
              });
              if (this.idioma == "ES") {
                this.$router.push({
                  name: "LoginMaster",
                  query: { idioma: "ES" },
                });
              } else {
                this.$router.push({
                  name: "LoginMaster",
                  query: { idioma: "EN" },
                });
              }
            } else if (response.data.estado === 1) {
              this.$fire({
                title: response.data.mensaje,
                confirmButtonText: this.idioma == "ES" ? "Aceptar" : "Accept"
              });
            }
          })
          .catch(e => {
            this.ManejarExcepcion(e);
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/estilos/estilosgenerales.scss";
.nav-masters {
  background-color: #ffffff;
  border-style: none;
}
.principal {
  text-align: center;
  padding-bottom: 6px;
  background: linear-gradient(
    90deg,
    #9e6353 0%,
    #a16555 22.05%,
    #a86d5b 31.23%,
    #b57a65 38.02%,
    #ca9076 43.63%,
    #e6ad8d 48.46%,
    #f6be9a 50.49%,
    #eeb590 51.88%,
    #dea47d 55.64%,
    #d39770 60.13%,
    #cd9168 65.98%,
    #cb8f66 78.29%,
    #9e6353 100%
  );
  background-size: 100% 5px;
}
.logo-embajadores {
  cursor: pointer;
  height: 80px;
  width: 180px;
  margin-right: 25px;
}

.div-login {
  background: url("../../../../public/img/images/ciudad2.png") no-repeat center
    center fixed;
  background-size: cover;
  height: 100vh;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contenedor-login {
  width: 20vw;
}

.ingresa {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 44px;
  color: #ffffff;
  text-align: center;
  letter-spacing: 0.05em;
}
.input-login {
  margin-top: 10px;
  height: 50px;
  border-radius: 0px;
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  color: rgba(30, 33, 32, 0.55);
  border-style: none;
}

.etiqueta {
  color: #ffffff;
  font-size: 12px;
  font-family: "Poppins";
  font-weight: bold;
}

.lista-reglas {
  color: #ffffff;
  font-size: 12px;
  font-family: "Poppins";
}

.form-control:focus {
  color: #495057;
  background-color: #ffffff;
  border-color: #ffffff;
  outline: none;
  box-shadow: none;
}

.form-check {
  position: relative;
  display: block;
  margin-left: -20px;
  margin-bottom: 10px;
}
.btn-login {
  margin-top: 10px;
  border: 1px solid $color-primario;
  border-radius: 0px;
  height: 50px;
  font-style: normal;
  font-weight: normal;
  color: #ffffff;
  background-color: $color-primario;
  font-family: $poppins;
}

.inner-addon {
  position: relative;
}

.icono-pass {
  color: #b8725a !important;
}
.inner-addon .icono-pass {
  position: absolute;
  padding: 17px;
  margin-left: -30px;
}

/* align glyph */
.left-addon .icono-pass {
  left: 0px;
}
.right-addon .icono-pass {
  right: 0px;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}
.right-addon input {
  padding-right: 30px;
}

@media all and (max-width: 767px) {
  .contenedor-login {
    margin-top: -45%;
    width: 75vw;
  }
  .input-login {
    height: 40px;
  }
  .btn-login {
    height: 40px;
  }
}
</style>
